import { CirclesThreeIcon, CubeIcon, FileArrowUpIcon, FunnelSimpleIcon, LockSimpleIcon } from '@phosphor-icons/react'

export const viewStatuses = {
  changes: 'changes',
  default: 'default',
}

export const sectionIds = {
  defaultViews: 'defaultViews',
  sharedViews: 'sharedViews',
  privateViews: 'privateViews',
}

export const sections = [
  {
    label: 'Vistas predefinidas',
    id: sectionIds.defaultViews,
    Icon: CubeIcon,
  },
  {
    label: 'Vistas compartidas',
    id: sectionIds.sharedViews,
    Icon: CirclesThreeIcon,
  },
  {
    label: 'Vistas privadas',
    id: sectionIds.privateViews,
    Icon: LockSimpleIcon,
  },
]

export const viewTypes = {
  generalTransactions: 'generalTransactions',
  transactions: 'transactions',
  shipmentsOutbound: 'shipmentsOutbound',
  shipmentsInbound: 'shipmentsInbound',
  inventory: 'inventory',
}

export const actionSectionIds = {
  views: 'views',
  importExport: 'importExport',
}

export const actionSections = [
  {
    label: 'Vistas',
    id: actionSectionIds.views,
    Icon: FunnelSimpleIcon,
  },
  {
    label: 'Importar/exportar',
    id: actionSectionIds.importExport,
    Icon: FileArrowUpIcon,
  },
]
